import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
  zIndex: 1000
}

const modalStyle = {
  position: 'relative',
  width: 'min(100%, 960px)',
  backgroundColor: '#000',
  borderRadius: '0.75rem',
  overflow: 'hidden',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)'
}

const closeButtonStyle = {
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  width: '2rem',
  height: '2rem',
  border: 0,
  borderRadius: '9999px',
  background: 'rgba(0, 0, 0, 0.6)',
  color: '#fff',
  fontSize: '1.25rem',
  lineHeight: 1,
  cursor: 'pointer',
  zIndex: 1
}

const iframeWrapStyle = {
  position: 'relative',
  width: '100%',
  paddingTop: '56.25%'
}

const iframeStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  border: 0
}

const triggerButtonStyle = {
  border: '1px solid #d73968',
  backgroundColor: '#d73968',
  color: '#fff',
  borderRadius: '0.5rem',
  padding: '0.625rem 1rem',
  fontWeight: 700,
  cursor: 'pointer'
}

export const YouTubeModal = ({ videoId, buttonLabel, buttonClassName, title, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      return undefined
    }

    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }

    window.addEventListener('keydown', onKeyDown)

    return () => {
      document.body.style.overflow = originalOverflow
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [isOpen])

  return (
    <>
      <button
        type='button'
        className={buttonClassName}
        style={!buttonClassName ? triggerButtonStyle : undefined}
        onClick={() => setIsOpen(true)}
      >
        {children || buttonLabel}
      </button>

      {isOpen ? (
        <div
          style={overlayStyle}
          role='dialog'
          aria-modal='true'
          aria-label={title}
          onClick={() => setIsOpen(false)}
        >
          <div style={modalStyle} onClick={(event) => event.stopPropagation()}>
            <button type='button' aria-label='Close video' style={closeButtonStyle} onClick={() => setIsOpen(false)}>
              ×
            </button>
            <div style={iframeWrapStyle}>
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0`}
                title={title}
                style={iframeStyle}
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                referrerPolicy='strict-origin-when-cross-origin'
                allowFullScreen
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}

YouTubeModal.defaultProps = {
  buttonLabel: 'Watch Video',
  buttonClassName: '',
  title: 'YouTube video player',
  children: null
}

YouTubeModal.propTypes = {
  videoId: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  buttonClassName: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
}
